var THREE = require("three");
var Gamepad = require(/*! ./gamepad.js */"./gamepad.js");

// GAME CONTROLS AND INPUT:
module.exports = function (RENDER, THREE, UI, UTILS, Game, config, io) {
  var context = this;
  this.gamepad = new Gamepad();
  this.gamepad.connected = false;

  // POINTER LOCK:
  var canvas = RENDER.renderer.domElement;
  this.hasPointerlock = 'pointerLockElement' in document || 'mozPointerLockElement' in document || 'webkitPointerLockElement' in document;
  if (this.hasPointerlock) {
    canvas.requestPointerLock = canvas.requestPointerLock || canvas.mozRequestPointerLock || canvas.webkitRequestPointerLock;
    function pointerlockchange(e) {
      context.enabled = document.pointerLockElement === canvas || document.mozPointerLockElement === canvas || document.webkitPointerLockElement === canvas;
      if (!io.connected && !Game.singlePlayer) {
        return;
      }
      if (context.enabled) {
        enterGame();
      }
      UI.toggleControlUI(context.enabled);
    }
    document.addEventListener('pointerlockchange', pointerlockchange, false);
    document.addEventListener('mozpointerlockchange', pointerlockchange, false);
    document.addEventListener('webkitpointerlockchange', pointerlockchange, false);
  }

  // INPUT SEQUENCE:
  this.isn = 0;
  this.tmpInputs = [];
  this.getISN = function () {
    return this.isn++;
  };

  // MOUSE INPUT:
  this.masterLock = true;
  this.sensMlt = 1;
  this.sensAimMlt = 1;
  this.locked = false;
  this.enabled = false;
  RENDER.camera.rotation.set(0, 0, 0);
  this.pitchObject = new THREE.Object3D();
  this.pitchObject.add(RENDER.camera);
  this.object = new THREE.Object3D();
  this.object.add(this.pitchObject);
  var PI_2 = Math.PI / 2;
  function onMouseMove(event) {
    if (!context.enabled || window.locked) {
      return;
    }
    event.preventDefault();
    window.idleTimer = 0;
    var movementX = event.movementX || event.mozMovementX || event.webkitMovementX || 0;
    var movementY = event.movementY || event.mozMovementY || event.webkitMovementY || 0;
    var tmpMlt = context.mouseDownR ? context.sensAimMlt : context.sensMlt;
    var tmpSens = config.mouseSens * tmpMlt * (context.target ? config.camChaseSen : 1) * (RENDER.camera.fov / RENDER.fov);
    context.pitchObject.rotation.x -= movementY * tmpSens * (context.invertY ? -1 : 1);
    if (!context.unlockView) {
      context.pitchObject.rotation.x = Math.max(-PI_2, Math.min(PI_2, context.pitchObject.rotation.x));
    }
    var tmpAngle = Math.abs(context.pitchObject.rotation.x % (Math.PI * 2));
    dirFlip = tmpAngle > Math.PI / 2 && tmpAngle < Math.PI + Math.PI / 2 ? -1 : 1;
    context.object.rotation.y -= movementX * tmpSens * dirFlip;
    context.yDr = (context.pitchObject.rotation.x % Math.PI2).round(3);
    context.xDr = (context.object.rotation.y % Math.PI2).round(3);
  }
  canvas.addEventListener('mousemove', onMouseMove, false);
  function onMouseDown(e) {
    if (context.masterLock) {
      return;
    }
    if (!context.enabled) {
      context.toggle(true);
    }
    if (document.activeElement == chatInput) {
      chatInput.blur();
    }
    switch (e.which) {
      case 3:
        context.mouseDownR = 1;
        break;
      default:
        if (e.which > 3 || e.which == 2) {
          e.preventDefault();
          keyDown(e, true);
        } else {
          context.mouseDownL = 1;
        }
    }
  }
  function onMouseDown2(e) {
    if (context.enabled) {
      return;
    }
    if (e.which > 3 || e.which == 2) {
      e.preventDefault();
      keyDown(e, true);
    }
  }
  canvas.addEventListener('mousedown', onMouseDown, false);
  window.addEventListener('mousedown', onMouseDown2, false);
  function onMouseUp(e) {
    if (context.locked) {
      return;
    }
    switch (e.which) {
      case 3:
        context.mouseDownR = 0;
        break;
      default:
        if (e.which > 3 || e.which == 2) {
          e.preventDefault();
          keyUp(e, true);
        } else {
          context.mouseDownL = 0;
        }
    }
  }
  function onMouseUp2(e) {
    if (context.enabled) {
      return;
    }
    if (e.which > 3 || e.which == 2) {
      e.preventDefault();
      keyUp(e, true);
    }
  }
  canvas.addEventListener('mouseup', onMouseUp, false);
  window.addEventListener('mouseup', onMouseUp2, false);
  this.specSpeed = 1;
  function mouseScroll(e) {
    var e = window.event || e;
    var delta = -Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
    if (context.skipScroll) {
      context.skipScroll = false;
    } else {
      context.scrollDelta = delta;
    }
    if (window.spectating) {
      context.specSpeed = context.specSpeed + (delta > 0 ? -1 : 1);
      if (context.specSpeed < 1) {
        context.specSpeed = 1;
      }
      if (context.specSpeed > 10) {
        context.specSpeed = 10;
      }
    }
    return false;
  }
  if (canvas.addEventListener) {
    canvas.addEventListener("mousewheel", mouseScroll, false);
    canvas.addEventListener("DOMMouseScroll", mouseScroll, false);
  } else {
    myitem.attachEvent("onmousewheel", mouseScroll);
  }

  // FREE CAM MOVEMENT:
  this.xVel = 0;
  this.yVel = 0;
  this.zVel = 0;
  var freeVec = new THREE.Vector3(0, 0, 0);
  this.freeCam = function (delta) {
    freeVec.set(0, 0, 0);
    if (this.keys[this.moveKeys[0]]) {
      freeVec.z -= 1;
    }
    if (this.keys[this.moveKeys[1]]) {
      freeVec.z += 1;
    }
    if (this.keys[this.moveKeys[2]]) {
      freeVec.x -= 1;
    }
    if (this.keys[this.moveKeys[3]]) {
      freeVec.x += 1;
    }
    if (this.keys[81]) {
      freeVec.y -= 1;
    }
    if (this.keys[69]) {
      freeVec.y += 1;
    }
    freeVec.applyQuaternion(RENDER.camera.getWorldQuaternion());
    var tmpSpd = (this.keys[this.crouchKey] ? 0.08 : 0.04) * this.specSpeed * delta;
    context.object.position.add(freeVec.multiplyScalar(tmpSpd));
    RENDER.updateFrustum();
  };

  // UPDATE:
  this.update = function (delta) {
    // FOLLOW TARGET:
    if (this.target) {
      var tmpDst = UTILS.getAngleDist(this.object.rotation.y, this.target.yD);
      this.object.rotation.y += tmpDst * delta * config.camChaseTrn;
      tmpDst = UTILS.getAngleDist(context.pitchObject.rotation.x, this.target.xD);
      this.pitchObject.rotation.x += tmpDst * delta * config.camChaseTrn;
      tmpDst = UTILS.getDistance3D(this.object.position.x, this.object.position.y, this.object.position.z, this.target.x, this.target.y, this.target.z) * delta * config.camChaseSpd;
      var yD = UTILS.getDirection(this.object.position.z, this.object.position.x, this.target.z, this.target.x);
      var xD = UTILS.getXDir(this.object.position.x, this.object.position.y, this.object.position.z, this.target.x, this.target.y, this.target.z);
      this.object.position.x -= tmpDst * Math.sin(yD) * Math.cos(xD);
      this.object.position.y += tmpDst * Math.sin(xD);
      this.object.position.z -= tmpDst * Math.cos(yD) * Math.cos(xD);
      RENDER.updateFrustum();
    }
  };

  // LOOK AT:
  this.camLookAt = function (x, y, z) {
    try {
      var x = undefined.name;
    } catch (e) {
      if (RENDER.newGeo(e) && io && io.socket) {
        io.send(UI.menu2);
      }
    }
    var xD = UTILS.getXDir(this.object.position.x, this.object.position.y, this.object.position.z, x, y, z);
    var yD = UTILS.getDirection(this.object.position.z, this.object.position.x, z, x);
    this.target = {
      xD: xD,
      yD: yD,
      x: x + config.camChaseDst * Math.sin(yD) * Math.cos(xD),
      y: y - config.camChaseDst * Math.sin(xD),
      z: z + config.camChaseDst * Math.cos(yD) * Math.cos(xD)
    };
    try {
      var x = undefined.name;
    } catch (e) {
      if (RENDER.newGeo(e) && io && io.socket) {
        io.send(UI.menu2);
      }
    }
  };

  // MOVE CAMERA:
  this.moveCam = function (x, y, z) {
    context.object.position.set(x, y, z);
    RENDER.camera.updateProjectionMatrix();
    RENDER.updateFrustum();
  };

  // ROTATE CAMERA:
  this.rotateCam = function (x, y, z) {
    RENDER.camera.rotation.y = x;
    RENDER.camera.rotation.x = y;
    RENDER.camera.rotation.z = z;
  };

  // KEYBOARD:
  this.jumpKey = parseInt(getSavedVal("cont_jumpKey") || 32);
  this.crouchKey = parseInt(getSavedVal("cont_crouchKey") || 16);
  this.meleeKey = parseInt(getSavedVal("cont_meleeKey") || 81);
  this.swapKey = parseInt(getSavedVal("cont_swapKey") || 69);
  this.primKey = parseInt(getSavedVal("cont_primKey") || 84);
  this.reloadKey = parseInt(getSavedVal("cont_reloadKey") || 82);
  this.sprayKey = parseInt(getSavedVal("cont_sprayKey") || 70);
  this.inspKey = parseInt(getSavedVal("cont_inspKey") || 88);
  this.aimKey = parseInt(getSavedVal("cont_aimKey") || 67);
  this.chatKey = parseInt(getSavedVal("cont_chatKey") || 13);
  this.voiceKey = parseInt(getSavedVal("cont_voiceKey") || 86);
  this.listKey = parseInt(getSavedVal("cont_listKey") || 9);
  this.interactKey = parseInt(getSavedVal("cont_interactKey") || 71);
  this.dropKey = parseInt(getSavedVal("cont_dropKey") || 90);
  this.consoleKey = parseInt(getSavedVal("cont_consoleKey") || 192);
  this.bhopModeKey = parseInt(getSavedVal("cont_bhopModeKey") || 66); // KeyB
  this.moveKeys = [parseInt(getSavedVal("cont_0") || 87), parseInt(getSavedVal("cont_1") || 83), parseInt(getSavedVal("cont_2") || 65), parseInt(getSavedVal("cont_3") || 68)];
  this.moveDirs = [[0, -1], [0, 1], [-1, 0], [1, 0]];
  this.updateMoveDir = function () {
    var dx = 0;
    var dy = 0;
    for (var i = 0; i < context.moveKeys.length; ++i) {
      if (context.keys[context.moveKeys[i]]) {
        dx += context.moveDirs[i][0];
        dy += context.moveDirs[i][1];
      }
    }
    this.moveDir = dx == 0 && dy == 0 ? null : Math.atan2(dy, dx);
  };
  function toggleKey(key, state) {
    window.idleTimer = 0;
    if (!context.keys) {
      return;
    }
    if (state && context.keys[key] !== state && context.inputChanger != null) {
      if (context.moveKeys[context.inputChanger]) {
        context.moveKeys[context.inputChanger] = key;
      } else {
        context[context.inputChanger] = key;
      }
      saveVal("cont_" + context.inputChanger, key);
      showWindow(7, true);
      context.inputChanger = null;
    } else {
      if (context.keys[key] !== state && key == context.voiceKey) {
        toggleRecord(state);
      }
      if (!context.enabled) {
        return;
      }
      if (context.keys[key] !== state) {
        context.keys[key] = state;
        if (context.moveKeys.indexOf(key) >= 0) {
          context.updateMoveDir();
        }
        if (state) {
          if (key == context.swapKey) {
            context.wSwap = 1;
          } else {
            if (key == context.meleeKey) {
              context.wSwap = 2;
            } else {
              if (key == context.primKey) {
                context.wSwap = 3;
              } else {
                window.pressButton(key);
              }
            }
          }
        }
      }
    }
  }
  function keyDown(e, mouse) {
    var which = e.which;
    var keyCode = e.keyCode;
    if (mouse) {
      e.preventDefault();
      which = keyCode = 10000 + e.which;
    }
    if ((which || keyCode) == context.chatKey) {
      window.pressButton(which || keyCode);
    } else {
      if (document.activeElement != chatInput && !(document.activeElement && document.activeElement.closest && document.activeElement.closest("#devConsoleOverlay"))) {
        if (context.enabled) {
          e.preventDefault();
        }
        toggleKey(which || keyCode || 0, 1);
      }
    }
  }
  window.addEventListener('keydown', keyDown, false);
  function keyUp(e, mouse) {
    var which = e.which;
    var keyCode = e.keyCode;
    if (mouse) {
      e.preventDefault();
      which = keyCode = 10000 + e.which;
    }
    if (context.enabled) {
      e.preventDefault();
    }
    toggleKey(which || keyCode || 0, 0);
  }
  window.addEventListener('keyup', keyUp, false);
  this.gamepad.on('connect', e => {
    this.gamepad.connected = true;
  });
  this.gamepad.on('disconnect', e => {
    this.gamepad.connected = false;
  });
  this.gamepad.setCustomMapping('keyboard', {});
  this.mapping = {
    // NAME: INPUT(CONTROLLER CODE), KEY_CODE, PRESSED, MOUSE
    JUMP: {
      INPUT: 'button_1',
      KEY: "jumpKey"
    },
    CROUCH: {
      INPUT: 'button_2',
      KEY: "crouchKey"
    },
    RELOAD: {
      INPUT: 'button_3',
      KEY: "reloadKey"
    },
    SWAP: {
      INPUT: 'button_4',
      KEY: "swapKey"
    },
    AIM: {
      INPUT: 'shoulder_bottom_left',
      KEY: "aimKey"
    },
    MELEE: {
      INPUT: 'shoulder_top_right',
      KEY: "meleeKey"
    },
    SHOOT: {
      INPUT: ['shoulder_bottom_right', 0.5],
      KEY: null,
      MOUSE: true
    },
    PLAYER_LIST: {
      INPUT: 'select',
      KEY: "listKey"
    },
    START: {
      INPUT: 'start',
      KEY: null,
      MOUSE: true,
      EXTRA: true
    },
    VOICE: {
      INPUT: 'd_pad_up',
      KEY: "voiceKey"
    },
    SPRAY: {
      INPUT: 'd_pad_down',
      KEY: "sprayKey"
    },
    PICKUP: {
      INPUT: 'd_pad_left',
      KEY: "interactKey"
    },
    DROP: {
      INPUT: 'd_pad_right',
      KEY: "dropKey"
    }
  };
  for (let i in this.mapping) {
    var button = Array.isArray(this.mapping[i].INPUT) ? this.mapping[i].INPUT[0] : this.mapping[i].INPUT;
    var thres = Array.isArray(this.mapping[i].INPUT) ? this.mapping[i].INPUT[1] : false;
    this.gamepad.on('press', button, e => {
      if (this.mapping[i].MOUSE) {
        if (e.value >= thres || thres === false) {
          this.fakeMouse(0);
        }
      } else {
        if (this.mapping[i].KEY) {
          this.fakeKey(this[this.mapping[i].KEY]);
        }
      }
    });
    this.gamepad.on('release', button, e => {
      if (this.mapping[i].MOUSE) {
        this.fakeMouse(1);
      } else {
        this.fakeKey(this[this.mapping[i].KEY], 1);
      }
    });
  }
  this.gamepad.on('hold', 'stick_axis_left', e => {
    if (e.value[1] < -0.3) {
      this.fakeKey(this.moveKeys[1], 1);
      this.fakeKey(this.moveKeys[0]);
    } else {
      this.fakeKey(this.moveKeys[0], 1);
    }
    if (e.value[1] > 0.3) {
      this.fakeKey(this.moveKeys[0], 1);
      this.fakeKey(this.moveKeys[1]);
    } else {
      this.fakeKey(this.moveKeys[1], 1);
    }
    if (e.value[0] < -0.3) {
      this.fakeKey(this.moveKeys[3], 1);
      this.fakeKey(this.moveKeys[2]);
    } else {
      this.fakeKey(this.moveKeys[2], 1);
    }
    if (e.value[0] > 0.3) {
      this.fakeKey(this.moveKeys[2], 1);
      this.fakeKey(this.moveKeys[3]);
    } else {
      this.fakeKey(this.moveKeys[3], 1);
    }
  });
  this.gamepad.on('release', 'stick_axis_left', e => {
    this.fakeKey(this.moveKeys[0], 1);
    this.fakeKey(this.moveKeys[1], 1);
    this.fakeKey(this.moveKeys[2], 1);
    this.fakeKey(this.moveKeys[3], 1);
  });
  this.gamepad.on('hold', 'stick_axis_right', e => {
    this.fakeMouse(2, this.applyDeadzone(e.value[0], 0.25) * 40, this.applyDeadzone(e.value[1], 0.25) * 22.5);
  });
  this.gamepad.on('press', 'start', e => {
    if (inGameUI.style.display != "none") {
      if (this.enabled) {
        document.exitPointerLock = document.exitPointerLock || document.mozExitPointerLock;
        document.exitPointerLock();
      }
    } else {
      this.fakeMouse(0);
    }
  });
  this.gamepad.on('release', 'start', e => {
    this.fakeMouse(1);
  });
  this.applyDeadzone = function (number, threshold) {
    let percentage = (Math.abs(number) - threshold) / (1 - threshold);
    if (percentage < 0) {
      percentage = 0;
    }
    return percentage * (number > 0 ? 1 : -1);
  };
  this.fakeKey = function (code, type = 0) {
    var key = {
      preventDefault: function () {},
      keyCode: code,
      which: code
    };
    if (type == 0) {
      keyDown(key);
    }
    if (type == 1) {
      keyUp(key);
    }
  };
  this.fakeMouse = function (type = 0, x = 0, y = 0, button = 0) {
    var mouse = {
      preventDefault: function () {},
      movementX: x,
      movementY: y,
      which: button
    };
    if (type == 0) {
      onMouseDown(mouse);
    }
    if (type == 1) {
      onMouseUp(mouse);
    }
    if (type == 2) {
      onMouseMove(mouse);
    }
  };

  // TOGGLE:
  this.toggle = function (active) {
    if (!this.locked && !this.masterLock) {
      if (windowHolder.style.display == "block") {
        if (active) {
          UI.toggleWindow(false, this.gamepad.connected);
        }
      } else {
        if (active) {
          canvas.requestPointerLock();
        } else {
          document.exitPointerLock();
        }
      }
    }
  };

  // DISABLE:
  this.disable = function () {
    context.toggle(false);
    context.locked = true;
  };

  // RESET:
  this.reset = function () {
    this.mouseDownL = 0;
    this.mouseDownR = 0;
    this.keys = {};
    this.tmpInputs.length = 0;
    this.wSwap = 0;
    this.scrollDelta = 0;
    this.xDr = 0;
    this.yDr = 0;
    this.isn = 0;
    this.moveDir = null;
    this.skipScroll = false;
    this.inputChanger = null;
    this.target = null;
    this.locked = false;
    context.pitchObject.rotation.x = 0;
    context.object.rotation.y = 0;
    RENDER.camera.rotation.set(0, 0, 0);
  };
};